
import lang from 'quasar/lang/ru.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import './fonts/Averia Sans Libre/Averia Sans Libre.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-icons-round/material-icons-round.css'
import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Notify from 'quasar/src/plugins/notify/Notify.js';;
import './styles/quasar.sass'
import setCssVar from 'quasar/src/utils/css-var/set-css-var.js';;

//setCssVar('primary', '#dfddd2');

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
	  Notify,
	  Dialog
  },
  lang: lang
}
